@if (loadState() === 'loaded' && detail(); as d) {
  <ai-knowledge-knowledge-base-detail-sources-table
    [detail]="d"
    [canShare]="canShare()"
    [editingEnabled]="editingEnabled()"
    [isBusy]="isBusy()"
    [previousPageUrl]="previousPageUrl"
    [previousPageTitle]="previousPageTitle"
    (share)="onShare($event)"
    (addSource)="onAddSource($event)"
    (removeSource)="onRemoveSource($event)"
    (revokeShare)="onRevokeShare($event)"
  />
} @else {
  <glxy-page [pagePadding]="false" [isLoading]="loadState() === 'loading'">
    <glxy-page-toolbar>
      <glxy-page-nav>
        @if (previousPageUrl) {
          <glxy-page-nav-button
            [previousPageTitle]="(previousPageTitle ?? 'KNOWLEDGE_SHARING.DETAIL.BACK') | translate"
            [previousPageUrl]="previousPageUrl"
          ></glxy-page-nav-button>
        }
      </glxy-page-nav>
      <glxy-page-title>{{ 'KNOWLEDGE' | translate }}</glxy-page-title>
    </glxy-page-toolbar>

    @if (loadState() === 'not-found') {
      <glxy-empty-state class="detail-page__empty">
        <glxy-empty-state-hero>
          <mat-icon>search_off</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>
          {{ 'KNOWLEDGE_SHARING.DETAIL.NOT_FOUND_TITLE' | translate }}
        </glxy-empty-state-title>
        <p>{{ 'KNOWLEDGE_SHARING.DETAIL.NOT_FOUND_DESCRIPTION' | translate }}</p>
        @if (previousPageUrl) {
          <glxy-empty-state-actions>
            <button mat-stroked-button (click)="back()">
              {{ 'KNOWLEDGE_SHARING.DETAIL.BACK' | translate }}
            </button>
          </glxy-empty-state-actions>
        }
      </glxy-empty-state>
    } @else if (loadState() === 'error') {
      <glxy-empty-state class="detail-page__empty">
        <glxy-empty-state-hero>
          <mat-icon>error_outline</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>
          {{ 'KNOWLEDGE_SHARING.DETAIL.LOAD_ERROR_TITLE' | translate }}
        </glxy-empty-state-title>
        <p>{{ 'KNOWLEDGE_SHARING.DETAIL.LOAD_ERROR_DESCRIPTION' | translate }}</p>
        <glxy-empty-state-actions>
          <button mat-stroked-button (click)="retry()">
            {{ 'KNOWLEDGE_SHARING.DETAIL.RETRY' | translate }}
          </button>
        </glxy-empty-state-actions>
      </glxy-empty-state>
    }
  </glxy-page>
}
